export default __webpack_public_path__ + "static/media/ZeroButton.b9d3349d.svg";